/* globals Craft $ */

class Analytics {
  constructor(consent) {
    if (consent && Craft.env == "production") {
      this.initGtm();
      this.initMatomo();
    }
  }

  initGtm() {
    if (!Craft.currentSite.gtmId) {
      return;
    }
    $("body").append(
      `
      <!-- Google Tag Manager -->
      <script nonce="` +
        Craft.nonce +
        `">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','` +
        Craft.currentSite.gtmId +
        `');</script>
      <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=` +
        Craft.currentSite.gtmId +
        `"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>
        </noscript>
      <!-- End Google Tag Manager -->`,
    );
  }

  initMatomo() {
    if (!Craft.currentSite.matomoId) {
      return;
    }
    $("body").append(
      `<!-- Matomo -->
      <script nonce="` +
        Craft.nonce +
        `">
      var _paq = window._paq = window._paq || [];
      _paq.push(["disableCookies"]);
      _paq.push(["trackPageView"]);
      _paq.push(["enableLinkTracking"]);
      (function() {
        var u="https://smhn.matomo.cloud/";
        _paq.push(["setTrackerUrl", u+"matomo.php"]);
        _paq.push(["setSiteId", "` +
        Craft.currentSite.matomoId +
        `"]);
        var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0];
        g.async=true; g.src="https://cdn.matomo.cloud/smhn.matomo.cloud/matomo.js"; g.nonce="` +
        Craft.nonce +
        `";s.parentNode.insertBefore(g,s);
      })();</script>
      <noscript>
          <p>
            <img
              referrerpolicy="no-referrer-when-downgrade"
              src="https://smhn.matomo.cloud/matomo.php?idsite=` +
        Craft.currentSite.matomoId +
        `&amp;rec=1"
              style="border:0;"
              alt=""
            />
          </p>
        </noscript>
        <!-- End Matomo -->`,
    );
  }
}

export { Analytics };
